
import leafImage from '../assets/leaf.png';
// Note: Make sure to add curriculum.jpg to the assets folder
import React, { useState, useEffect } from 'react';

import value1 from '../assets/curriculum1.jpg';
import value2 from '../assets/curriculum2.jpg';
import value3 from '../assets/curriculum3.jpg';
import value4 from '../assets/curriculum4.jpg';
import value5 from '../assets/curriculum5.webp';
import value6 from '../assets/curriculum6.webp';
import value7 from '../assets/curriculum7.webp';
import value8 from '../assets/curriculum8.webp';
import value9 from '../assets/curriculum9.jpg';


// Custom styles for Curriculum component
const styles = `

.curriculum-section {
    background-color: #FFFDF7;
    position: relative;
    overflow: hidden;
    padding: 80px 0;
}

/* Decorative circle - Top Right */
.curriculum-decoration-circle-right {
    position: absolute;
    top: -80px;
    right: -80px;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Leaf overlay on circle - Top Right */
.curriculum-decoration-leaf-right {
    position: absolute;
    top: -60px;
    right: -60px;
    width: 240px;
    height: 240px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
    z-index: 2;
    pointer-events: none;
}

/* Decorative circle - Center Left */
.curriculum-decoration-circle-left {
    position: absolute;
    top: 50%;
    left: -100px;
    transform: translateY(-50%);
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Leaf overlay on circle - Center Left */
.curriculum-decoration-leaf-left {
    position: absolute;
    top: 50%;
    left: -80px;
    transform: translateY(-50%);
    width: 180px;
    height: 180px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
    z-index: 2;
    pointer-events: none;
}

.curriculum-content-wrapper {
    position: relative;
    z-index: 3;
}

/* Main Heading */
.curriculum-main-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.8rem;
    font-weight: 800;
    color: #5A3411;
    margin-bottom: 25px;
}

/* Content Text */
.curriculum-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.1rem;
    font-weight: 500;
    color: rgba(90, 52, 17, 0.8);
    line-height: 1.75;
    margin-bottom: 20px;
    text-align: justify;
}

/* Section Heading */
.curriculum-section-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.2rem;
    font-weight: 800;
    color: #5A3411;
    text-align: center;
    margin: 50px 0 30px 0;
}

/* Bullet Points Section */
.curriculum-bullets-section {
    background-color: #F5F1E9;
    border-radius: 20px;
    padding: 30px 40px;
    margin-bottom: 40px;
    position: relative;
    overflow: hidden;
}

/* Leaf background in bullets section */
.curriculum-bullets-section::before {
    content: '';
    position: absolute;
    top: 0;
    right: -20%;
    width: 80%;
    height: 100%;
    background-image: url(${leafImage});
    background-size: contain;
    background-position: right center;
    background-repeat: no-repeat;
    opacity: 0.08;
    pointer-events: none;
    z-index: 0;
}

.curriculum-bullet-list {
    list-style: none;
    padding: 0;
    margin: 0;
    position: relative;
    z-index: 1;
}

.curriculum-bullet-item {
    display: flex;
    align-items: flex-start;
    gap: 15px;
    padding: 15px 0;
    border-bottom: 1px solid rgba(90, 52, 17, 0.1);
}

.curriculum-bullet-item:last-child {
    border-bottom: none;
}

.curriculum-bullet-dot {
    width: 10px;
    height: 10px;
    min-width: 10px;
    background-color: #5A3411;
    border-radius: 50%;
    margin-top: 8px;
}

.curriculum-bullet-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.1rem;
    color: #5A3411;
    font-weight: 600;
    line-height: 1.6;
    margin: 0;
}

/* Curriculum Image */
.curriculum-image-wrapper {
    border-radius: 20px;
    overflow: hidden;
    margin-bottom: 50px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    max-height: 450px;
}

.curriculum-image {
    width: 100%;
    height: 100%;
    max-height: 450px;
    display: block;
    object-fit: cover;
    object-position: center;
}

/* Bottom Section */
.curriculum-bottom-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.2rem;
    font-weight: 800;
    color: #5A3411;
    margin-bottom: 25px;
}

.curriculum-bottom-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.1rem;
    font-weight: 500;
    color: rgba(90, 52, 17, 0.8);
    line-height: 1.75;
    margin-bottom: 15px;
}

/* Contact Button */
.curriculum-btn {
    background-color: #FF800D;
    color: white;
    font-family: 'Quicksand', sans-serif;
    font-size: 1rem;
    font-weight: 600;
    padding: 12px 30px;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
    margin-top: 15px;
}

.curriculum-btn:hover {
    background-color: #e67300;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(255, 128, 13, 0.3);
}

/* Responsive Styles */
@media (max-width: 1199.98px) {
    .curriculum-section {
        padding: 70px 0;
    }
    
    .curriculum-main-heading {
        font-size: 2.3rem;
    }
    
    .curriculum-section-heading {
        font-size: 1.8rem;
    }
    
    .curriculum-bottom-heading {
        font-size: 1.8rem;
    }
}

@media (max-width: 991.98px) {
    .curriculum-section {
        padding: 60px 0;
    }
    
    .curriculum-main-heading {
        font-size: 2rem;
    }
    
    .curriculum-section-heading {
        font-size: 1.6rem;
        margin: 40px 0 25px 0;
    }
    
    .curriculum-bullets-section {
        padding: 25px 30px;
    }
    
    .curriculum-bottom-heading {
        font-size: 1.6rem;
    }
    
    .curriculum-text,
    .curriculum-bottom-text {
        font-size: 0.95rem;
    }
    
    .curriculum-decoration-circle-right {
        width: 220px;
        height: 220px;
        top: -70px;
        right: -70px;
    }
    
    .curriculum-decoration-leaf-right {
        width: 190px;
        height: 190px;
        top: -50px;
        right: -50px;
    }
    
    .curriculum-decoration-circle-left {
        width: 160px;
        height: 160px;
        left: -80px;
    }
    
    .curriculum-decoration-leaf-left {
        width: 140px;
        height: 140px;
        left: -60px;
    }
}

@media (max-width: 767.98px) {
.ethics-values-section {
        padding: 40px 0 0 0;
    }
    .curriculum-section {
        padding: 50px 0;
    }
    
    .curriculum-main-heading {
        font-size: 1.75rem;
        margin-bottom: 20px;
    }
    
    .curriculum-section-heading {
        font-size: 1.5rem;
        margin: 35px 0 20px 0;
    }
    
    .curriculum-bullets-section {
        padding: 20px 25px;
        border-radius: 16px;
    }
    
    .curriculum-bullet-item {
        padding: 12px 0;
        gap: 12px;
    }
    
    .curriculum-bullet-text {
        font-size: 0.95rem;
    }
    
    .curriculum-bottom-heading {
        font-size: 1.4rem;
        margin-bottom: 20px;
    }
    
    .curriculum-text,
    .curriculum-bottom-text {
        font-size: 0.9rem;
        line-height: 1.65;
    }
    
    .curriculum-decoration-circle-right {
        width: 180px;
        height: 180px;
        top: -60px;
        right: -60px;
    }
    
    .curriculum-decoration-leaf-right {
        width: 150px;
        height: 150px;
        top: -40px;
        right: -40px;
    }
    
    .curriculum-decoration-circle-left {
        width: 140px;
        height: 140px;
        left: -70px;
    }
    
    .curriculum-decoration-leaf-left {
        width: 120px;
        height: 120px;
        left: -55px;
    }
    
    .curriculum-image-wrapper {
        max-height: 350px;
    }
    
    .curriculum-image {
        max-height: 350px;
    }
    
    .curriculum-btn {
        padding: 10px 25px;
        font-size: 0.95rem;
    }
        .ethics-carousel-wrapper {
        height: 380px;
        border-radius: 16px;
    }
}

@media (max-width: 575.98px) {
.ethics-carousel-wrapper {
        height: 360px;
        border-radius: 16px;
    }
.ethics-values-section {
        padding: 30px 0 0 0;
    }
    .curriculum-section {
        padding: 40px 0;
    }
    
    .curriculum-main-heading {
        font-size: 1.5rem;
        margin-bottom: 18px;
    }
    
    .curriculum-section-heading {
        font-size: 1.3rem;
        margin: 30px 0 18px 0;
    }
    
    .curriculum-bullets-section {
        padding: 18px 20px;
        border-radius: 14px;
    }
    
    .curriculum-bullet-item {
        padding: 10px 0;
        gap: 10px;
    }
    
    .curriculum-bullet-dot {
        width: 8px;
        height: 8px;
        min-width: 8px;
        margin-top: 5px;
    }
    
    .curriculum-bullet-text {
        font-size: 0.85rem;
    }
    
    .curriculum-bottom-heading {
        font-size: 1.25rem;
    }
    
    .curriculum-text,
    .curriculum-bottom-text {
        font-size: 0.85rem;
        line-height: 1.6;
        margin-bottom: 12px;
    }
    
    .curriculum-image-wrapper {
        border-radius: 14px;
        margin-bottom: 35px;
        max-height: 300px;
    }
    
    .curriculum-image {
        max-height: 300px;
    }
    
    .curriculum-decoration-circle-right {
        width: 140px;
        height: 140px;
        top: -50px;
        right: -50px;
    }
    
    .curriculum-decoration-leaf-right {
        width: 120px;
        height: 120px;
        top: -35px;
        right: -35px;
    }
    
    .curriculum-decoration-circle-left {
        width: 110px;
        height: 110px;
        left: -55px;
    }
    
    .curriculum-decoration-leaf-left {
        width: 95px;
        height: 95px;
        left: -45px;
    }
    
    .curriculum-btn {
        padding: 10px 22px;
        font-size: 0.9rem;
    }
}

@media (max-width: 400px) {
.ethics-carousel-wrapper {
        height: 340px;
        border-radius: 16px;
    }
.ethics-values-section {
        padding: 30px 0 0 0;
    }
    .curriculum-section {
        padding: 35px 0;
    }
    
    .curriculum-main-heading {
        font-size: 1.3rem;
    }
    
    .curriculum-section-heading {
        font-size: 1.15rem;
    }
    
    .curriculum-bullets-section {
        padding: 15px 18px;
        border-radius: 12px;
    }
    
    .curriculum-bullet-text {
        font-size: 0.8rem;
    }
    
    .curriculum-bottom-heading {
        font-size: 1.1rem;
    }
    
    .curriculum-text,
    .curriculum-bottom-text {
        font-size: 0.8rem;
    }
    
    .curriculum-decoration-circle-right {
        width: 110px;
        height: 110px;
        top: -40px;
        right: -40px;
    }
    
    .curriculum-decoration-leaf-right {
        width: 95px;
        height: 95px;
        top: -28px;
        right: -28px;
    }
    
    .curriculum-decoration-circle-left {
        width: 90px;
        height: 90px;
        left: -45px;
    }
    
    .curriculum-decoration-leaf-left {
        width: 75px;
        height: 75px;
        left: -35px;
    }
    
    .curriculum-image-wrapper {
        border-radius: 12px;
        max-height: 250px;
    }
    
    .curriculum-image {
        max-height: 250px;
    }
    
    .curriculum-btn {
        padding: 8px 20px;
        font-size: 0.85rem;
    }
        .ethics-carousel-pagination {
        bottom: 20px;
        gap: 8px;
    }
        }
    .ethics-values-section {
    position: relative;
    padding: 40px 0 40px 0;
    z-index: 1;
    }
    .ethics-carousel-wrapper {
    position: relative;
    width: 100%;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.ethics-carousel-track {
    display: flex;
    transition: transform 0.5s ease-in-out;
}

.ethics-carousel-card {
    flex: 0 0 calc(25% - 12px);
    margin: 0 6px;
    position: relative;
    height: 438px;
    border-radius: 16px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.ethics-carousel-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}

.ethics-carousel-pagination {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 20px 0;
    z-index: 3;
}
    .ethics-pagination-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: none;
    background-color: rgba(90, 52, 17, 0.3);
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
}

.ethics-pagination-dot.active {
    background-color: #FF800D;
    transform: scale(1.3);
}

/* Mobile: Show 1 card at a time */
@media (max-width: 991.98px) {
    .ethics-carousel-card {
        flex: 0 0 100%;
        margin: 0;
        height: 500px;
        border-radius: 24px;
    }
}

@media (max-width: 767.98px) {
    .ethics-carousel-card {
        height: 438px;
    }
}

@media (max-width: 575.98px) {
    .ethics-carousel-card {
        height: 400px;
    }
}

@media (max-width: 400px) {
    .ethics-carousel-card {
        height: 350px;
    }
}
`;

const CurriculumSection = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const bulletPoints = [
        "Cooking & Baking, Woodwork, Sewing & Textiles",
        "Dance Movement, Football & Outdoor Play",
        "Swimming & Cycling",
        "Yoga, Mindfulness & Healthy Habits",
        "Local & Wider Trips To Parks, Farms, Museums & Landmarks"
    ];
    const slides = [
        { image: value1 },
        { image: value2 },
        { image: value3 },
        { image: value4 },
        { image: value5 },
        { image: value6 },
        { image: value7 },
        { image: value8 },
        { image: value9 }
    ];

    // Determine visible cards based on screen width
    const [visibleCards, setVisibleCards] = useState(4);
    const [isTransitioning, setIsTransitioning] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            setVisibleCards(window.innerWidth <= 991 ? 1 : 4);
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Duplicate slides for infinite loop effect
    const infiniteSlides = [...slides, ...slides];
    const totalOriginalSlides = slides.length;

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((current) => current + 1);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    // Reset to beginning seamlessly when we've scrolled through all original slides
    useEffect(() => {
        if (activeIndex >= totalOriginalSlides) {
            // Wait for transition to complete, then reset without animation
            const timeout = setTimeout(() => {
                setIsTransitioning(false);
                setActiveIndex(0);
                // Re-enable transition after reset
                setTimeout(() => setIsTransitioning(true), 50);
            }, 500);
            return () => clearTimeout(timeout);
        }
    }, [activeIndex, totalOriginalSlides]);

    // Calculate slide offset (each card is 25% width on desktop, 100% on mobile)
    const cardWidth = visibleCards === 1 ? 100 : 25;
    const translateX = activeIndex * cardWidth;

    return (
        <>
            <style>{styles}</style>
            <section className="curriculum-section">
                {/* Decorative Circle - Top Right */}
                <div className="curriculum-decoration-circle-right"></div>
                {/* Decorative Leaf - Top Right */}
                <div
                    className="curriculum-decoration-leaf-right"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>
                {/* Decorative Circle - Center Left */}
                <div className="curriculum-decoration-circle-left"></div>
                {/* Decorative Leaf - Center Left */}
                <div
                    className="curriculum-decoration-leaf-left"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>

                <div className="container">
                    <div className="curriculum-content-wrapper">
                        {/* Main Heading */}
                        <h2 className="curriculum-main-heading">Our Curriculum</h2>

                        {/* Intro Text */}
                        <p className="curriculum-text">
                            At Zubis Nursery, our curriculum nurtures the whole child — their curiosity, confidence, and creativity. Guided by the Early Years Foundation Stage (EYFS) and Development Matters, it is designed to be unique, inspiring, and full of wonder, allowing children to learn at their own pace in warm, cosy, and natural spaces inspired by Hygge and The Curiosity Approach®.
                        </p>

                        <p className="curriculum-text">
                            Our curriculum grows with your child — from the Baby Room to Preschool — ensuring smooth progression while building confidence, independence, and essential skills.
                        </p>

                        {/* Nurturing Section */}
                        <h3 className="curriculum-section-heading">Nurturing Hands-On Experiences</h3>

                        {/* Bullet Points */}
                        <div className="curriculum-bullets-section">
                            <ul className="curriculum-bullet-list">
                                {bulletPoints.map((point, index) => (
                                    <li key={index} className="curriculum-bullet-item">
                                        <span className="curriculum-bullet-dot"></span>
                                        <p className="curriculum-bullet-text">{point}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="ethics-values-section">
                            <div className="ethics-carousel-wrapper">
                                <div
                                    className="ethics-carousel-track"
                                    style={{
                                        transform: `translateX(-${translateX}%)`,
                                        transition: isTransitioning ? 'transform 0.5s ease-in-out' : 'none'
                                    }}
                                >
                                    {infiniteSlides.map((slide, index) => (
                                        <div
                                            key={index}
                                            className="ethics-carousel-card"
                                            style={{ backgroundImage: `url(${slide.image})` }}
                                        />
                                    ))}
                                </div>
                            </div>
                            <div className="ethics-carousel-pagination">
                                {slides.map((_, index) => (
                                    <button
                                        key={index}
                                        className={`ethics-pagination-dot ${(activeIndex % totalOriginalSlides) === index ? 'active' : ''}`}
                                        onClick={() => setActiveIndex(index)}
                                        aria-label={`Go to slide ${index + 1}`}
                                    />
                                ))}
                            </div>
                        </div>

                        {/* Bottom Section */}
                        <h3 className="curriculum-bottom-heading">Belonging, Inclusion, and Growing Together</h3>

                        <p className="curriculum-bottom-text">
                            We are committed to inclusive practice, ensuring children with SEND are supported through personalised, thoughtfully adapted experiences. Every child feels valued, confident, and successful in our care.
                        </p>

                        <p className="curriculum-bottom-text">
                            We build strong partnerships with families through stay-and-play sessions and parent workshops, helping them connect more closely with their child's learning.
                        </p>

                        <p className="curriculum-bottom-text">
                            Through our curiosity-led, Hygge-inspired approach, children leave Zubis Nursery confident, capable, and prepared for the next stage of their journey.
                        </p>

                        {/* Contact Button */}
                        <a href="/contact" className="curriculum-btn">Contact Our Team</a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default CurriculumSection;
